package com.evoapps.evoshift.ui.reports

import androidx.compose.runtime.Composable

/** No question before an export here: the [FileSaver] decides (SH-161 F4). */
@Composable
actual fun ExportChoiceHost() = Unit
